import React from "react"

import cellStyles from './cell_styles.module.scss'

const ColumnHeader = ({ displayName, refName, currentSort, sortDirection, key }) => {

    // set active sort //
    var isActiveSort = false

    if (refName === currentSort) {
        isActiveSort = true
    }


    return (

        <div className={cellStyles.column_header_wrapper} key={key}>
            <div className={cellStyles.column_header_inner} data-active={isActiveSort}>
                <p className={cellStyles.column_header_p}>
                    {displayName} {isActiveSort ? sortDirection === 'asc' ? <span className={cellStyles.sortSpan}>&#9650;</span> : <span className={cellStyles.sortSpan}>&#9660;</span> : ''}
                </p>
            </div>
        </div>

    )

}

export default ColumnHeader